import { render, staticRenderFns } from "./BtnLgPrimary.vue?vue&type=template&id=d531f11c&scoped=true"
import script from "./BtnLgPrimary.vue?vue&type=script&lang=js"
export * from "./BtnLgPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d531f11c",
  null
  
)

export default component.exports